<app-common-header
  [isAdminOrTutor]="role === '1' || role === '2'"
></app-common-header>
<div class="body">
    <div class="mainContent">
        <div class="list-of-classes">
            <span class="list-of-classes__heading">Classes and Links </span>
           
                <div
                class="list-of-classes__report"
                *ngFor="let class of student_classes; let i = index"
                >

                    <div class="course-material__upload__heading"> 
                          
                        <button class="course-material__upload__heading--submit"  (click) ="openZoom(class['classUrl1'])">
                            <mat-icon class="course-material__upload__heading__icon">videocam</mat-icon>Join Zoom
                        </button>                  
                        <div> 
                            <span class="course-material__upload__heading--title">{{ class["course"] }}  
                            </span>
                            <span class="course-material__upload__heading--title-yellow">{{ class["subject_display_name"] }}  
                            </span>
                        </div>     
                        <span class="course-material__upload__heading--title-md"> {{ class["day_display_name"] }}  {{ class["startTime"] }}  - {{ class["endTime"] }} {{ class["zone_display_name"] }} </span>
                        <div>
                            <span class="course-material__upload__heading--title-yellow-sm">  Instructor - {{ class["tutor"] }}    </span>
                            <span class="course-material__upload__heading--title-sm">  {{ class["type_display_name"] }}   </span>
                        </div>
                    
                        <div>
                            <p class="course-material__upload__heading--title-md">
                                {{ class["classUrl2"] }}
                            </p>  
                        </div>
                    </div>
                </div>
           
        </div>
    </div>
    <app-footer></app-footer>
</div>